import { render } from "./ReportListView.vue?vue&type=template&id=1d68c1b2"
import script from "./ReportListView.vue?vue&type=script&lang=js"
export * from "./ReportListView.vue?vue&type=script&lang=js"

import exportComponent from "/builds/sptbr/sysa.ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__